import * as React from 'react';
/**
 *
 * Original name: Stack Exchange
 *
 * Figma URL: https://www.figma.com/file/RPY7Gy4EixfwdOtVIf2PaX/_Global---Icons?node-id=22733%3A2874
 *
 */
export const StackExchangeExternalLogo = (props) => (React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", ...props },
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16.547 4H7.196C5.988 4 5 5.006 5 6.25v.733h13.688V6.25c0-1.245-.952-2.251-2.141-2.251Zm2.14 3.77H5v2.818h13.688V7.77Zm0 3.641H5v2.818h13.688v-2.818ZM5 15.766v-.732h13.78v.732c0 1.245-.989 2.251-2.197 2.251h-.64L13.052 21v-2.983H7.196C5.988 18.017 5 17.011 5 15.767Z", fill: "currentColor", vectorEffect: "non-scaling-stroke" })));
